import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import { IChargeItem, IChargePrice } from 'src/app/pages/core/models/Commerce';
import { ErrorHandlingService } from 'src/app/pages/core/services/utils/error-handling.service';
import errors from 'src/app/pages/core/utils/errorCodes';
import { ChargeConfirmComponent } from './charge-confirm/charge-confirm.component';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-charge-form',
  templateUrl: './charge-form.component.html',
  styleUrls: ['./charge-form.component.scss'],
})
export class ChargeFormComponent implements OnInit {
  formGroup: FormGroup;
  dialogOpened = false;
  loading = false;
  constructor(
    private cryptoSvc: CryptoService,
    private dialog: MatDialog,
    private errorHandler: ErrorHandlingService,
  ) {}

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      name: new FormControl('', [Validators.required]),
      desc: new FormControl('', []),
      price: new FormControl('', [Validators.required, this.priceValidator]),
      currency: new FormControl('ARS', [Validators.required]),
    });
  }

  getErrorMessage(input: string): string {
    const keys = Object.keys(this.formGroup.controls[input].errors);
    if (keys.length === 0) {
      return '';
    }
    if (keys.includes('min')) {
      return 'El monto debe ser mayor a 0';
    }
    return errors[keys[0]];
  }

  priceValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (+control.value <= 0) {
      return { min: true };
    }
    return null;
  }

  createCharge() {
    this.loading = true;
    const chargePrice: IChargePrice = {
      amount: this.formGroup.controls.price.value,
      currency: this.formGroup.controls.currency.value,
    };
    const chargeItem: IChargeItem = {
      id: Date.now().toString(),
      name: this.formGroup.controls.name.value,
      desc: this.formGroup.controls.desc.value,
      price: this.formGroup.controls.price.value + ' ' + this.formGroup.controls.currency.value,
    };

    this.cryptoSvc.createCharge(chargePrice, [chargeItem]).subscribe(
      (res) => {
        if (res) {
          this.formGroup.reset();
          this.formGroup.controls.currency.setValue('ARS');
          this.dialogOpened = true;
          this.dialog
            .open(ChargeConfirmComponent, {
              panelClass: 'modal-container',
              maxWidth: '90vw',
              maxHeight: '90vh',
              data: {
                charge: res,
              },
            })
            .afterClosed()
            .subscribe(() => {
              this.dialogOpened = false;
            });
          this.loading = false;
        }
      },
      (err) => {
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: this.errorHandler.handleChargeError(err),
        });
        this.loading = false;
      },
    );
  }
}
